export function isExamIngesting(
  instancesLastUpdatedAt: Nullable<Date | string>,
  timeoutMs: number
): boolean {
  // timeoutMs <= 0 means the indicator is gated off (e.g. flag unset or not enabled for this client).
  if (timeoutMs <= 0 || !instancesLastUpdatedAt) return false;
  return Date.now() - new Date(instancesLastUpdatedAt).getTime() < timeoutMs;
}

// ms remaining until the ingestion timeout elapses, clamped to 0.
export function getIngestionExpiryDelayMs(
  instancesLastUpdatedAt: Nullable<Date | string>,
  timeoutMs: number
): number {
  if (timeoutMs <= 0 || !instancesLastUpdatedAt) return 0;
  const elapsed = Date.now() - new Date(instancesLastUpdatedAt).getTime();
  return Math.max(timeoutMs - elapsed, 0);
}
